"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeName = void 0;
var TypeName;
exports.TypeName = TypeName;

(function (TypeName) {
  TypeName["BIKE_PARK"] = "BikePark";
  TypeName["BIKE_RENTAL_STATION"] = "BikeRentalStation";
  TypeName["CAR_PARK"] = "CarPark";
  TypeName["QUAY"] = "Quay";
  TypeName["STOP_PLACE"] = "StopPlace";
})(TypeName || (exports.TypeName = TypeName = {}));